import { BE_SERVER_ENDPOINT } from '../constants/configs';

export let currentAuthToken = null;
export let preview = false;

export function setAuthToken(authToken){
    currentAuthToken = authToken;
}

export function enablePreview(){
  preview = true;
}

export function getAuthToken(){
    return currentAuthToken;
}

export function isPreview(){
  return preview;
}

export function updateToPreviewEndpoint(endpoint){
  let urlSplit = endpoint.split(BE_SERVER_ENDPOINT);
  return urlSplit[0] + BE_SERVER_ENDPOINT + "/preview" + urlSplit[1];
}
